export const iconFontAwesomeMapsLightbulb = (
	<i className="fa-solid fa-lightbulb"></i>
);
